import { useState } from 'react';
var isBrowser = typeof window !== 'undefined'; // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint

export var useLocalStorage = function useLocalStorage(key, initialValue) {
  var _useState = useState(function () {
    try {
      var item = isBrowser && window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.error(error);
      return initialValue;
    }
  }),
      storedValue = _useState[0],
      setStoredValue = _useState[1];

  var setValue = function setValue(value) {
    try {
      var valueToStore = typeof value === 'function' ? value(storedValue) : value; // eslint-disable-next-line @typescript-eslint/no-unsafe-argument

      setStoredValue(valueToStore);
      isBrowser && window.localStorage.setItem(key, JSON.stringify(valueToStore));
    } catch (error) {
      console.error(error);
    }
  };

  return [storedValue, setValue];
};